var _rect, _rect2, _g, _g2, _path, _path2, _path3, _path4, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#E8F5E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 5,
    fill: "none",
    stroke: "#43A047",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 50,
    fill: "#43A047"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 45,
    fill: "#81C784"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -10,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "LOYALTY"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 10,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "MEMBER"), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -60 L0 -70",
    stroke: "white",
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20 30 L20 30 L15 0 L-15 0 Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15 0 C-15 -20, -30 -30, -30 -40 C-30 -50, -20 -50, 0 -50 C20 -50, 30 -50, 30 -40 C30 -30, 15 -20, 15 0 Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 30,
    width: 50,
    height: 10,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 40,
    width: 10,
    height: 15,
    fill: "#FFC107"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 40 L350 40 L325 70 Z",
    fill: "#43A047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M500 40 L450 40 L475 70 Z",
    fill: "#43A047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300 160 L350 160 L325 130 Z",
    fill: "#43A047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M500 160 L450 160 L475 130 Z",
    fill: "#43A047"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#2E7D32",
    textAnchor: "middle"
  }, "LOYALTY BONUS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#2E7D32",
    textAnchor: "middle"
  }, "10% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#388E3C",
    textAnchor: "middle"
  }, "Special discount for our loyal customers")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyBonus);
export default __webpack_public_path__ + "static/media/loyalty_bonus.5a227714c5ee890c108d273ec605ff86.svg";
export { ForwardRef as ReactComponent };